import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { InventoryItems } from '../components/inventory/InventoryItems';
import { Orders } from '../components/inventory/Orders';

export const Inventory = () => {
  const { t, language } = useLanguage();
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'orders';

  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold tracking-tight mb-6" lang={language === 'ar' ? 'ar' : 'en'} data-testid="inventory-title">
        {t('inventory')}
      </h1>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="mb-6">
          <TabsTrigger value="orders" data-testid="tab-orders">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('orders')}</span>
          </TabsTrigger>
          <TabsTrigger value="items" data-testid="tab-items">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('inventoryItems')}</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="orders">
          <Orders />
        </TabsContent>
        <TabsContent value="items">
          <InventoryItems />
        </TabsContent>
      </Tabs>
    </div>
  );
};